<div id="heading">
    <h1>Alumni</h1>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item" routerLink="/"><a href="#">Home</a></li>
            <li class="breadcrumb-item"><a href="#">Alumni</a></li>
            <li class="breadcrumb-item active" aria-current="page">Institutional Message </li>
        </ol>
    </nav>
</div>

<div id="organ">
    <div class="container-fluid">
        <div class="card pl-3 pr-3 text-justify ml-lg-5">
            <h4 class="card-title text-center ">Institutional Message</h4>
            <div class="card-body text-justify">
                <p class="lead mb-4">
                    <iframe src="https://drive.google.com/file/d/1V_8AlZ2K0JvprOATOFqeshDDLCGNufzY/preview" width="100%" height="800px" allow="autoplay"></iframe>
            </div>
        </div>
    </div>
</div>